import { TimePair } from './types';

const DAY_DURATION_MIN = 24 * 60;

export const checkForOverlappingTimePairs = (timePairs: TimePair[]) =>
  timePairs.length !== mergeOverlappingTimePairs(timePairs).length;

export const checkIf24h = (timePairs: TimePair[]) => {
  const mergedTimePairs = mergeOverlappingTimePairs(timePairs);
  const totalDuration = mergedTimePairs.reduce((acc, timePair) => {
    return acc + (timePair.endMinutes - timePair.startMinutes);
  }, 0);

  return totalDuration === DAY_DURATION_MIN;
};

export const mergeOverlappingTimePairs = (timePairs: TimePair[]) => {
  if (timePairs.length === 0) {
    return [];
  }

  const timePoints = timePairs
    .map(({ startMinutes, endMinutes }) => [
      {
        type: 'start',
        time: startMinutes,
      },
      {
        type: 'end',
        time: endMinutes,
      },
    ])
    .flat()
    .sort((a, b) => a.time - b.time);

  const mergedTimePairs = [];
  let startTime = timePoints[0].time;
  let startCount = 0;
  let endCount = 0;
  for (const currentTimePoint of timePoints) {
    if (currentTimePoint.type === 'start') {
      if (startCount === 0) {
        startTime = currentTimePoint.time;
      }
      startCount++;
    } else {
      endCount++;
      if (endCount === startCount) {
        mergedTimePairs.push({
          startMinutes: startTime,
          endMinutes: currentTimePoint.time,
        });
        startCount = 0;
        endCount = 0;
      }
    }
  }
  return mergedTimePairs;
};
